import React from 'react';
import { Outlet } from 'react-router-dom';
import UISideBar from '@/components/shared/UISideBar/UISideBar';
import UITopBar from '@/components/shared/UITopBar/UITopBar';
import MainContent from '@/components/shared/MainContent/MainContent';
import './DashboardLayout.scss';
import { useScrollToAnchor } from '@/hooks/useScrollToAnchor';

const DashboardLayout: React.FC = () => {
  useScrollToAnchor();
  return (
    <div className="dashboard-layout">
      <UISideBar />
      <div className="dashboard-layout__main">
        <UITopBar />
        <MainContent>
          <Outlet />
        </MainContent>
      </div>
    </div>
  );
};

export default DashboardLayout;